<div class="cx-order-items" *ngIf="order$ | async as order">
  <ng-container *ngIf="!isServicePartsEnabled; else deliveryGroups">
    <h4 class="cx-order-items-header">
        {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}
    </h4>

    <gen-cart-item-list
      [groups]="order.entryGroups"
      [readonly]="true"
      [promotionLocation]="promotionLocation"
    ></gen-cart-item-list>
  </ng-container>

  <ng-template #deliveryGroups>
    <gen-shipping-groups
      [daFreeShipping]="order.daFreeShipping"
      [shippingGroups]="order.shippingGroups"
      [isOrderConfirmPage]="true">
    </gen-shipping-groups>
  </ng-template>
</div>
